
// => Styling
import styles from './MenuItem.module.css';

// => Icons
import { ReactComponent as Lock} from '../../../content/lock.svg';


// => React hooks
import { useRef } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';


// ============
// Component
// ============
const MenuItem = ({
    index = 0,
    isSelected = false,
    onSelected = (i) => {},
    title = "No title",
    desc = "No description...",
    clip = null,
    icon = null,
    onClicked = (i) => {},
    color = null,
    locked = false,
}) => {

    const refVid = useRef()

    const svgString = encodeURIComponent(renderToStaticMarkup(<Lock />))

    function onMouseOver() {
        onSelected(index)
        if (locked === false) {
            refVid.current?.play()
        }
    }
    function onMouseLeave() {
        onSelected(null)
        setTimeout(() => {
                refVid.current?.pause()
        }, 100);
        refVid.current.currentTime = 0
    }
    function checkClick() {
        if (!isSelected) return;
        if (locked) return;
        
        onClicked(index)
    }


    // RENDER
    // ---------
    return(
        <div className={styles.container} /*style={(index % 2 === 0) ? {background: '#000'} : {background: '#fff'}}*/
            onMouseOver={()=>onMouseOver()}
            onMouseLeave={()=>onMouseLeave()}
            onClick={()=>checkClick()}>

            <div className={styles.item}>

                <div className={styles.lock} style={{backgroundImage: locked ? `url('data:image/svg+xml;utf8, ${svgString}')` : 'none'}} />

                <video className={[styles.video, locked ? null : (isSelected ? styles.videoActive : null)].join(" ")}
                        ref={refVid}
                        src={clip}
                        controls={false}
                        loop playsInline muted />

                <div className={styles.menuColor} style={{background: locked ? 'none' : color}} />
                <div className={styles.overlayFx} />

                <div className={styles.titleRow}>
                    <div className={[styles.icon, isSelected ? styles.iconActive : null].join(" ")}>{icon}</div>
                    <div className={[styles.title, isSelected ? styles.titleActive : null].join(" ")}>{title}</div>
                </div>
                
            </div>

        </div>
    )
}


export default MenuItem